import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Reveal, Overline, WorkCard, NewsCard } from "@/components/Shared";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function Lavori() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "svolti" ? "svolti" : "novita";
  const [novita, setNovita] = useState([]);
  const [svolti, setSvolti] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get("/projects", { params: { kind: "novita" } }),
      api.get("/projects", { params: { kind: "lavoro" } }),
    ])
      .then(([n, l]) => {
        setNovita(n.data);
        setSvolti(l.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="pt-28">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
          <Reveal>
            <Overline>Portfolio</Overline>
            <h1 className="mt-6 font-serif text-4xl font-light tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
              I nostri <span className="italic text-brand">lavori</span>
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600">
              Dai cantieri in corso alle opere consegnate: ogni edificio porta il nome di chi lo abita
              e la firma di chi lo ha costruito.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-14 sm:px-8 sm:py-20">
        <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
          <TabsList className="border border-slate-200 bg-obsidian">
            <TabsTrigger data-testid="tab-novita" value="novita" className="data-[state=active]:bg-gold data-[state=active]:text-white">
              Novità in cantiere
            </TabsTrigger>
            <TabsTrigger data-testid="tab-svolti" value="svolti" className="data-[state=active]:bg-brand data-[state=active]:text-white">
              Lavori già svolti
            </TabsTrigger>
          </TabsList>

          <TabsContent value="novita" className="mt-10">
            {loading ? (
              <p className="py-20 text-center text-sm text-slate-400">Caricamento…</p>
            ) : novita.length === 0 ? (
              <p data-testid="novita-empty" className="border border-dashed border-slate-300 py-20 text-center text-sm text-slate-400">
                Nessun cantiere attivo al momento. Torna presto a trovarci.
              </p>
            ) : (
              <>
                <p className="mb-8 text-sm text-slate-500">
                  Clicca su un progetto per aprire la sua scheda completa, con descrizione, altre foto e piantine.
                </p>
                <div data-testid="novita-card-grid" className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                  {novita.map((p, i) => (
                    <NewsCard key={p.id} p={p} index={i % 3} />
                  ))}
                </div>
              </>
            )}
          </TabsContent>

          <TabsContent value="svolti" className="mt-10">
            {loading ? (
              <p className="py-20 text-center text-sm text-slate-400">Caricamento…</p>
            ) : svolti.length === 0 ? (
              <p data-testid="lavori-empty" className="border border-dashed border-slate-300 py-20 text-center text-sm text-slate-400">
                Nessun lavoro presente. Torna presto a trovarci.
              </p>
            ) : (
              <div data-testid="lavori-card-grid" className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {svolti.map((p, i) => (
                  <WorkCard key={p.id} p={p} index={i % 3} />
                ))}
              </div>
            )}
          </TabsContent>
        </Tabs>
      </section>
    </main>
  );
}
